module.exports = __webpack_public_path__ + "static/media/GirlReflectedinKnife_jacket.359da3b1.jpg";